module.exports = __webpack_public_path__ + "static/media/adam_taylor_emirates_dubai_mall.e7a9ca3b.png";